var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import uid from 'uid';
//  without $id: String! apollo throws an error
export var getUserAnalytics = function () {
    var isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
    return {
        query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query($id: String!) {\n        userAnalytics(id: $id) @rest(type: \"UserAnalytics\", path: \"/user-analytics", "\", endpoint: \"query\") {\n          id\n          videosWatched\n          pagesVisited\n        }\n      }\n    "], ["\n      query($id: String!) {\n        userAnalytics(id: $id) @rest(type: \"UserAnalytics\", path: \"/user-analytics", "\", endpoint: \"query\") {\n          id\n          videosWatched\n          pagesVisited\n        }\n      }\n    "])), isIE ? "?randID=" + uid() : ''),
    };
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/getUserAnalytics.ts
// module id = 781
// module chunks = 81